export function buildWatchThemeKey(name: string, at: Date = new Date()): string {
  const slug = (name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  if (!slug) {
    return '';
  }
  const pad = (value: number) => value.toString().padStart(2, '0');
  const stamp = `${at.getFullYear()}${pad(at.getMonth() + 1)}${pad(at.getDate())}${pad(
    at.getHours(),
  )}${pad(at.getMinutes())}`;
  return `${slug}${stamp}`;
}

export function watchThemeBriefKind(fileName: string): string {
  const ext = fileName.split('.').pop()?.toLowerCase() || '';
  if (ext === 'jpeg') {
    return 'jpg';
  }
  return ext;
}

export function watchThemeBriefDisplayType(kind: string): string {
  if (kind === 'png' || kind === 'jpg') {
    return 'PNG mockup';
  }
  if (kind === 'txt' || kind === 'md') {
    return 'Text prompt';
  }
  if (kind === 'pdf') {
    return 'PDF';
  }
  if (kind === 'html') {
    return 'HTML mockup';
  }
  return kind.toUpperCase();
}

export function formatFileSizeLabel(bytes: number): string {
  if (!bytes && bytes !== 0) {
    return '';
  }
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  const kb = bytes / 1024;
  if (kb < 1024) {
    return `${kb < 10 ? kb.toFixed(1) : Math.round(kb)} KB`;
  }
  return `${(kb / 1024).toFixed(1)} MB`;
}
